module.exports = __webpack_public_path__ + "b1bf2469827c399a30dada1a9c66dda2.png";